import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import { Confirmation } from '../../..'

const ImageButton = styled.img`
    cursor: pointer;
    height: 35px;
    width: auto;

    &:hover {
        opacity: 0.5;
    }
`

const Screenshot = ({ src, srcHighRes, t }) => {
    const download = () => {
        const downloadTag = document.createElement('a')
        downloadTag.href = src
        downloadTag.click()
    }

    return (
        src && (
            <Confirmation
                confirmation={<img style={{ height: '60vh', maxWidth: '85vw' }} src={srcHighRes} alt="" />}
                header={t('screenshot')}
                ok={t('download')}
                cancel={t('close')}
                onCancel={() => null}
                onConfirm={download}
            >
                <ImageButton src={src} alt="" />
            </Confirmation>
        )
    )
}

Screenshot.propTypes = {
    src: PropTypes.string,
    t: PropTypes.func,
}

Screenshot.defaultProps = {
    buildSrc: '',
    t: () => null,
}

export default withTranslation()(Screenshot)
